const baseSize = 16;

function setRem() {
  // 获取视口宽度和高度
  const clientWidth = document.documentElement.clientWidth;
  const clientHeight = document.documentElement.clientHeight;
  
  // 计算基于宽度的缩放比例
  const scaleWidth = clientWidth / 1920;
  // 计算基于高度的缩放比例（假设设计稿高度为1080）
  const scaleHeight = clientHeight / 1080;
  
  // 使用较小的比例确保内容完全可见
  const scale = Math.min(scaleWidth, scaleHeight, 2);
  
  document.documentElement.style.fontSize = baseSize * scale + 'px';
}

// 初始化和窗口大小变化时调用
setRem();
window.onresize = setRem;